/**
 * Created by neo on 26.02.17.
 */
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import { translate  } from 'react-i18next';
import Flight from '../../Store/Flight';
import {Link} from 'react-router';
import moment from 'moment-timezone';

type Props = {
  flight: Flight,
  onClick: (flight: Flight) => void,
};

@observer
export class FlightCard extends Component {

  props: Props;

  handleClick = () => {
    this.props.onClick(this.props.flight);
  };

  render() {
    
    const { t, flight } = this.props;

    const images = flight.aircraft_offer.flight_offer.files.map(m => m.file);
    const randomIndex = Math.floor(Math.random() * images.length);
    const image = images[randomIndex] || { url: 'https://placeholdit.imgix.net/~text?txtsize=33&txt=350%C3%97150&w=350&h=150'};
    const flightOffer = this.props.flight.aircraft_offer.flight_offer;

    return (
      <Link to={`/flight/${flight.id}`} className="flight-offer-card" onClick={this.handleClick}>
        <div className='offer-card-image' style={{ backgroundImage: image ? `url('${image.url}')` : 'none' }}>
          <div className='image-overlay'></div>
        </div>
        <div className='offer-card-content'>
          <h2>{flightOffer.title}</h2>
          {moment(flight.start_time).format('l LT')}
          {flightOffer.location && flightOffer.location.name && (
            <div className='location'>
              {flightOffer.location.name + (flightOffer.durationInMinutes ? ` - ${flightOffer.durationInMinutes} min` : '')}
            </div>
          )}
          <div className='availableSeats'>
            {t('{{availableSeats}} Plätze noch übrig', { availableSeats: flight.available_seats })}
          </div>
        </div>
        <div className='offer-card-footer'>
          <div className='price'>
            <h3>
              {flight.aircraft_offer.price_passenger ? t('ab {{price}}{{currency}}', {
                price: flight.aircraft_offer.price_passenger,
                currency: flight.aircraft_offer.currency_code,
              }) : ''}
            </h3>
          </div>
          <button className='btn btn-primary'>{t('Jetzt Buchen')}</button>
        </div>
      </Link>
    );
  }
}

export default translate ()(FlightCard);



// WEBPACK FOOTER //
// ./src/App/Dashboard/Flight/FlightCard.js